<div>    
    <div *ngIf="gs.modified.item.underlyingRule.GameType == 8">
        <div class="glaeSegmentHeader" [ngClass]="{ 'legacy-styles-section': isCxone }" cvLocalizedText langSection="Games" langKey="Setup_Rewards_Title_Top_Team">Ranking Reward(s)</div>
        <div class="glaeSegmentText" [ngClass]="{ 'legacy-styles-sub-section': isCxone }" cvLocalizedText langSection="Games" langKey="Setup_Rewards_Top_Team">Choose one or more reward options to pay winners. Set the amount of rewards each participant will receive if their team wins. For example: if you set 25 coins, each member of the team will receive the 25 coins.</div>
    </div>

    <div *ngIf="gs.modified.item.underlyingRule.GameType != 8">
        <div class="glaeSegmentHeader" [ngClass]="{ 'legacy-styles-section': isCxone }" cvLocalizedText langSection="Games" langKey="Setup_Rewards_Title">Setup Reward(s)</div>
        <div class="glaeSegmentText" [ngClass]="{ 'legacy-styles-sub-section': isCxone }" cvLocalizedText langSection="Games" langKey="Setup_Rewards_Help">Choose one or more reward options to pay winners</div>
    </div>    

    <div *ngFor="let rewardLevel of rewardLevels; let i = index" class="my-3">        
        <div class="d-flex">
            <div class=" mt-1 topDogRankIcon topDogRank{{i+1}}"></div>            
            <div class="mr-4 mt-2">
                <span cvLocalizedText [ngClass]="{ 'legacy-styles-body-default': isCxone }" langSection="Games" langKey="Coin_Reward">Coin Reward</span>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text px-2 py-0 g-icon g-icon-coin"></span>                        
                    </div>
                    <input class="form-control form-control-lg no-spinner" type="number" cvLocalizedPlaceholder langSection="Games" langKey="Coins" [(ngModel)]="rewardLevel.Coins.rewardValue" (blur)="handleRewardBlur($event)" />
                </div>
            </div>
            <div class="mr-4 mt-2" *ngIf="!cvConfigurationService.isCxOne">
                <span cvLocalizedText langSection="Games" langKey="XP_Reward">XP Reward</span>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text px-2 py-0 g-icon g-icon-xp"></span>
                    </div>
                    <input class="form-control form-control-lg no-spinner" type="number" cvLocalizedPlaceholder langSection="Games" langKey="XP" [(ngModel)]="rewardLevel.XP.rewardValue" (blur)="handleRewardBlur($event)" />
                </div>
            </div>
            <div class="mr-4 mt-2 d-none">
                <span cvLocalizedText langSection="Games" langKey="Currency_Reward">Currency</span>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text px-2 py-0 g-icon g-icon-currency"></span>
                    </div>
                    <input class="form-control form-control-lg no-spinner" type="number" cvLocalizedPlaceholder langSection="Games" langKey="Currency" [(ngModel)]="rewardLevel.Currency.rewardValue" (blur)="handleRewardBlur($event);" />
                </div>                
            </div>
            <div>
                <div class="d-flex align-items-center">
                    <span class="d-block w-100 text-center" [ngClass]="{ 'legacy-styles-body-default': isCxone }" cvLocalizedText langSection="Games" langKey="Badge">Badge</span>
                </div>
                <div *ngIf="rewardLevel.Badge.rewardValue == 0" (click)="popBadgeSelector(rewardLevel);" class="cursor-pointer">
                    <div class="gamesAddBadgeIcon"></div>
                </div>
                <div *ngIf="rewardLevel.Badge.rewardValue > 0" (mouseover)="showRemove[i]=true" (mouseleave)="showRemove[i]=false" (click)="popBadgeSelector(rewardLevel)" class="cursor-pointer d-flex" [ngbPopover]="popoverTemplate" triggers="mouseenter:mouseleave" container="body" placement="left">
                    <img *ngIf="rewardLevel.Badge.rewardValue > 0" [src]="'../Admin/ImageResizer.aspx?imgid=' + rewardLevel.Badge.rewardValue + '&w=48&h=48'" />
                    <div class="d-flex" *ngIf="showRemove[i]" style="margin-left:-5px;">
                        <div (click)="removeBadge(rewardLevel.Badge); $event.stopPropagation();" class="removingBadge d-flex justify-content-center align-items-center">
                            <svg style="width:12px; height:12px;" class="fill-white"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>
                        </div>
                    </div>
                </div>
                <ng-template #popoverTemplate>
                    <div [innerHTML]="getPopoverTemplate(rewardLevel.Badge.rewardValue)"></div>
                </ng-template>
            </div>  
            <div class="ml-5 mt-2 pt-4">
                <svg class="icon-24 fill-valyrianSteel fill-hover-whaleTail" (click)="confirmRemoveLevel(rewardLevel, i)"><use href="../App_Themes/clearview-default/icons/utility/delete.svg#delete"></use></svg>
            </div>
        </div>
    </div>

    <button *ngIf="rewardLevels.length < 5" style="transition: none;" type="button" class="btn btn-text btn-icon" (click)="addNewLevel();">
        <svg class="icon-16 fill-cerulean"><use href="../App_Themes/clearview-default/icons/utility/add.svg#add"></use></svg>
        <span cvLocalizedText [ngClass]="{ 'legacy-styles-body': isCxone }" langSection="Games" langKey="Add_Another_Place">Add Another Place</span>
    </button>
    <button *ngIf="!cvConfigurationService.isCxOne && rewardLevels.length >= 5" style="transition: none;" type="button" class="btn btn-text" (click)="openMoreLevelsInfoBox(modalLevelsInfo);" cvLocalizedText langSection="Games" langKey="Need_More_Ranks_Link">Need more ranks? Click here to learn about the Rules Engine</button>
</div>

<ng-template #modalLevelsInfo let-modal>
    <div class="p-5">
        <button type="button" class="close position-absolute" style="right: 12px; top: 12px" (click)="closeModalInfo()" aria-label='Close'>
            <span aria-hidden="true">&times;</span>
        </button>
        <p cvLocalizedText langSection="Games" langKey="Need_More_Ranks_Message">
            Our Rules Engine is able to handle an unlimited number of Rank Levels (which work the same as Top Dog levels!) Click the link below to go to the Rules Engine.
        </p>
        <button type="button" class="btn btn-text" (click)="goToRules()" cvLocalizedText langSection="Games" langKey="Bullseye_To_Rules">Take me to the Rules Engine!</button>
    </div>
</ng-template>
